const ellipsisFileName = (fileName: any) => {
  const findIndex = fileName.indexOf("files");
  return fileName.charAt(findIndex + 5) === "/"
    ? fileName.slice(findIndex + 6, fileName.length)
    : "";
};
export default ellipsisFileName;
